import { HTTP } from './common'

export const LinkApi = {
  get_content (id) {
    return HTTP.get(`user/links/${id}/contents/`).then(response => {
      return response.data
    })
  },
  update_link(link, id, project_id) {
    return HTTP.post(`user/links/${id?id:link.id}/update_link/?project_id=`+project_id, link).then(response => {
      return response.data
    });
  },
  get (id, project_id, country_code) {
    return HTTP.get(`user/links/${id}/?project=${project_id}&country_code=${country_code}`).then(response => {
      return response.data
    })
  },
  list (query) {
    return HTTP.get(`user/links/?${query}`).then(response => {
      return response.data
    })
  },
  get_chart_data (id, state, key, country_code, project_id) {
    return HTTP.get(`user/links/${id}/chart_data/?state=${state}&key=${key}${country_code?'&country_code='+country_code:''}${project_id?'&project_id='+project_id:''}`).then(response => {
      return response.data
    })
  },
  get_chart_keyword (id) {
    return HTTP.get(`user/links/${id}/chart_keyword_link/`).then(response => {
      return response.data
    })
  },

};
